import { useAuth } from "context";

export function useAnalyticsEvent() {
  const { verifiedCustomer } = useAuth();
  const trackCustomEvent = (event, params = {}, includeUserContext = true) => {
    const context =
      includeUserContext && verifiedCustomer
        ? {
            user_id: verifiedCustomer.id,
            user_role: verifiedCustomer.role,
            user_type: verifiedCustomer.userType,
          }
        : {};

    if (window.dataLayer) {
      window.dataLayer.push({
        event,
        ...context,
        ...params,
        timestamp: new Date().toISOString(),
      });
    }
  };

  return { trackCustomEvent };
}
